import { createApp } from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import Vue3TreeOrg from 'vue3-tree-org';

import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';
import 'vue3-tree-org/lib/vue3-tree-org.css';

import store from './plugins/store'

const app = createApp(App);
app.config.errorHandler = (err, vm, info) => {
    console.error('Vue error in', vm?.$options?.name || '(anonymous)', info, err)
  }
app.use(vuetify);
app.use(store);
app.use(Vue3TreeOrg);
app.mount('#app');